import './_product-option-select.scss';
import component from './product-option-select';

export default component;
